import { useTranslation } from 'react-i18next';
import { Form, FormGroup } from '../../components/Form';
import {
  PageLayout,
  PageLayoutAside,
  PageLayoutMain,
  PageLayoutSection,
} from '../../components/PageLayout';
import { Skeleton } from '../../components/Skeleton';
import { SrOnly } from '../../components/SrOnly';
import { Stack, StackSmall } from '../../components/Stack';
import SkeletonTextBlock from './SkeletonTextBlock';
import { Wrapper } from './wrapper';

const SkeletonItemPage = () => {
  const { t } = useTranslation(['other']);

  return (
    <>
      <SrOnly>{t('skeletonLoading.content', { ns: 'other' })}</SrOnly>
      <Wrapper>
        <PageLayout>
          <PageLayoutMain>
            <PageLayoutSection>
              <Stack>
                <Skeleton $width="200px" $height="25px" />
              </Stack>
              <Stack>
                <SkeletonTextBlock />
              </Stack>
            </PageLayoutSection>
            <PageLayoutSection>
              <Stack>
                <Skeleton $width="150px" $height="25px" />
              </Stack>
              <Stack>
                <SkeletonTextBlock />
              </Stack>
            </PageLayoutSection>
          </PageLayoutMain>
          <PageLayoutAside>
            <PageLayoutSection $variant="asideCta">
              <StackSmall>
                <Skeleton $width="100%" $height="44px" />
              </StackSmall>
              <StackSmall>
                <Skeleton $width="100%" $height="44px" />
              </StackSmall>
            </PageLayoutSection>
            <PageLayoutSection>
              <Stack>
                <Skeleton $width="160px" $height="25px" />
              </Stack>
              <Stack>
                <Form>
                  <FormGroup>
                    <Skeleton $width="100%" $height="52px" />
                  </FormGroup>
                  <FormGroup>
                    <Skeleton $width="100%" $height="52px" />
                  </FormGroup>
                </Form>
              </Stack>
            </PageLayoutSection>
          </PageLayoutAside>
        </PageLayout>
      </Wrapper>
    </>
  );
};

export default SkeletonItemPage;
